import { Routes } from '@angular/router';
import { PublicLayoutComponent } from './layouts/public-layout/public-layout.component';
import { PrivateLayoutComponent } from './layouts/private-layout/private-layout.component';
import { LoginComponent } from './pages/login/login.component';
import { TrackingComponent } from './pages/tracking/tracking.component';
import { ContactsComponent } from './pages/contacts/contacts.component'; // Importa il componente Contatti
import { SupportComponent } from './pages/support/support.component'; // Importa il componente Supporto
import { HomeComponent } from './pages/home/home.component'; // Importa il componente Home
import { DashboardComponent } from './pages/dashboard/dashboard.component'; // Importa il componente Dashboard
import { ManifestComponent } from './pages/manifest/manifest.component'; // Importa il componente Manifest
import { AuthGuard } from './guards/auth.guard'; // Importa il guard
import { PublicGuard } from './guards/public.guard'; // Importa il PublicGuard
import { ProfileComponent } from './pages/profile/profile.component';
import { SettingsComponent } from './pages/settings/settings.component';
import { DamageDetailComponent } from './pages/damage-management/damage-detail/damage-detail.component'; // Importa il componente Damage Detail
import { AssignedDamagesComponent } from './pages/damage-management/damage-overview/assigned-damages/assigned-damages.component'; // Pratiche danno assegnate a me
import { DamageOverviewComponent } from './pages/damage-management/damage-overview/damage-overview.component'; // Panoramica danni (pratiche e colli, pagina principale)
import { DamageClientOverviewComponent } from './pages/damage-management/damage-client-overview/damage-client-overview.component'; // Panoramica clienti (pratiche danno per cliente)
import { DamagesDealerOverviewComponent } from './pages/damage-management/damages-dealer-overview/damages-dealer-overview.component'; // Panoramica dealer (pratiche danno per dealer)
import { RecoveryComponent } from './pages/recovery/recovery.component'; // Importa il componente di recupero password
import { RecoveryPasswordComponent } from './pages/recovery-password/recovery-password.component'; // Importa il componente di reset password
import { DetailsComponent } from './pages/details/details.component'; // Importa il componente Dettagli
import { SearchComponent } from './pages/search/search.component';
import { RoutingComponent } from './pages/routing/routing.component'; // Importa il componente Routing
import { TrackingDetailsComponent } from './pages/trackingDetails/trackingDetails.component';
import { OverviewComponent } from './pages/overview/overview.component';
import { StatisticsAffidatiComponent } from './pages/statistics-affidati/statistics-affidati.component';
import { StatisticsComponent } from './pages/statistics/statistics.component';
import { StatisticsConsegnatiComponent } from './pages/statistics-consegnati/statistics-consegnati.component';
import { StatisticsByDayComponent } from './pages/statistics-by-day/statistics-by-day.component';
import { ReturnsComponent } from './pages/returns/returns.component';
import { ReturnsHistoryComponent } from './pages/returns-history/returns-history.component';
import { StatisticsByDayReturnsComponent } from './pages/statistics-returns-by-day/statistics-returns-by-day.component';
import { ReturnsTotalComponent } from './pages/returns-total/returns-total.component';
import { PermissionGuard } from './guards/permission.guard';
import { ShipmentRequestComponent } from './pages/shipment-request/shipment-request.component';
import { ReturnRequestComponent } from './pages/return-request/return-request.component';
import { ReissueComponent } from './pages/reissue/reissue.component';
import { ShipmentManagementComponent } from './pages/shipment-management/shipment-management.component';
import { AboutComponent } from './pages/about/about.component';
import { StatisticsOpeByDayComponent } from './pages/statistics-ope-by-day/statistics-ope-by-day.component';
import { DealerListComponent } from './pages/anagraphic/dealer/dealer-list/dealer-list.component';
import { AnagraphicComponent } from './pages/anagraphic/anagraphic.component';
import { StatisticsKpiColliComponent } from './pages/statistics-kpi-colli/statistics-kpi-colli.component';
import { LoadingListComponent } from './pages/loading-list/loading-list.component';
import { LoadingListItemsComponent } from './pages/loading-list/loading-list-items/loading-list-items.component';
import {ChangeTourComponent} from "./pages/change-tour/change-tour.component";
import { OverviewHarmonizerComponent } from './pages/overview-harmonizer/overview-harmonizer.component';
import { MaintenanceComponent } from './pages/maintenance/maintenance.component';
import { DealerMassiveInsertComponent } from './pages/dealer-massive-insert/dealer-massive-insert.component';
import { SystemComponent } from './pages/system/system.component';
import { DiscrepancyListComponent } from './pages/discrepancy-list/discrepancy-list.component';
import { DamageManagementComponent } from './pages/damage-management/damage-management.component'; // Gestione Danni (pagina di ingresso)
import { CreateDamageComponent } from './pages/damage-management/damage-overview/create-damage/create-damage.component';
import { environment } from '../environments/environment';
import { RegistrationComponent } from './pages/registration/registration.component';
import { OverviewWarehouseComponent } from './pages/overview-warehouse/overview-warehouse.component';
import { TripManagementComponent } from './pages/trip-management/trip-management.component';
import { OverviewPickingComponent } from './pages/overview-picking/overview-picking.component';
import { StockComponent } from './pages/stock/stock.component';

const maintenanceRoutes: Routes = [
  { path: 'maintenance', component: MaintenanceComponent },
  { path: '**', redirectTo: 'maintenance' }
];

export const applicationRoutes: Routes = [  {
    path: '',
    component: PublicLayoutComponent,
    canActivate: [PublicGuard],
    children: [
      { path: '', component: HomeComponent }, // Aggiunta rotta per la home page
      { path: 'login', component: LoginComponent },
      { path: 'recovery', component: RecoveryComponent },
      { path: 'recovery-password', component: RecoveryPasswordComponent },
      { path: 'registration', component: RegistrationComponent },
      { path: 'tracking', component: TrackingComponent },
      { path: 'tracking/:code', component: TrackingDetailsComponent }, // Rotta con codice dinamico
      { path: 'contacts', component: ContactsComponent }, // Aggiunta rotta Contatti
      { path: 'support', component: SupportComponent }, // Aggiunta rotta Supporto
      { path: 'tos', // Termini di servizio e Privacy (versione pubblica; quella privata è /private/tos)
        loadComponent: () => import('./pages/tos/tos.component').then(m => m.TosComponent)
      },
    ],
  },  {
    path: '',
    component: PrivateLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'dashboard',
        component: DashboardComponent
      },
      { path: 'private/tracking', component: TrackingComponent },
      { path: 'private/tracking/:code', component: TrackingDetailsComponent },
      { path: 'manifest', 
        component: ManifestComponent, 
        canActivate: [PermissionGuard], 
        data: { functionName: 'manifest' } 
      },
      { path: 'profile', 
        component: ProfileComponent, 
        canActivate: [PermissionGuard], 
        data: { functionName: 'profile' } 
      },
      { path: 'settings',
        component: SettingsComponent
      },
      { path: 'routing', 
        component: RoutingComponent, 
        canActivate: [PermissionGuard], 
        data: { functionName: 'routing' } 
      },
      // Gestione Danni: pagina di ingresso della gestione danni (resoconto e
      // funzionalità), funzione dei permessi "damages". È la prima rotta della
      // funzione, così la dashboard la sceglie come entrypoint (getRouteByFunctionName)
      { path: 'damage-management',
        component: DamageManagementComponent,
        canActivate: [PermissionGuard],
        data: { functionName: 'damages' }
      },
      // Panoramica danni: pratiche e colli danneggiati su tutti i dati, stessa funzione dei permessi "damages"
      { path: 'damage-overview',
        component: DamageOverviewComponent,
        canActivate: [PermissionGuard],
        data: { functionName: 'damages' }
      },
      // Panoramica clienti: stesse pratiche di /damage-overview viste per cliente, stessa funzione dei permessi "damages"
      { path: 'damages-client-overview',
        component: DamageClientOverviewComponent,
        canActivate: [PermissionGuard],
        data: { functionName: 'damages' }
      },
      // Panoramica dealer: stesse pratiche e colli viste per dealer, stessa funzione dei permessi "damages"
      { path: 'damages-dealer-overview',
        component: DamagesDealerOverviewComponent,
        canActivate: [PermissionGuard],
        data: { functionName: 'damages' }
      },
      // Apertura di una nuova pratica danno su un collo (dalla tabella Colli delle panoramiche)
      { path: 'damage-overview/create/:parcelCode',
        component: CreateDamageComponent,
        canActivate: [PermissionGuard],
        data: { functionName: 'damages' }
      },
      // Dettaglio pratica danno: stessa funzione dei permessi di /damage-overview
      // ("damages/detail" non esiste tra le funzioni utente e il guard
      // rimandava alla dashboard chi non è admin)
      { path: 'damage-overview/detail/:id',
        component: DamageDetailComponent,
        canActivate: [PermissionGuard],
        data: { functionName: 'damages' }
      },
      // Pratiche danno assegnate all'utente collegato: stessa funzione dei permessi di /damage-overview
      { path: 'damage-overview/assigned',
        component: AssignedDamagesComponent,
        canActivate: [PermissionGuard],
        data: { functionName: 'damages' }
      },
      { path: 'manifest/details/:code', 
        component: DetailsComponent, 
        canActivate: [PermissionGuard], 
        data: { functionName: 'manifest/details' } 
      },
      { path: 'search', 
        component: SearchComponent, 
        canActivate: [PermissionGuard], 
        data: { functionName: 'search' } 
      },
      {
        path: 'overview',
        component: OverviewComponent,
        canActivate: [PermissionGuard],
        data: { functionName: 'overview' }
      },
      {
        path: 'overview-harmonizer',
        component: OverviewHarmonizerComponent,
        canActivate: [PermissionGuard],
        data: { functionName: 'overview-harmonizer' }
      },
      {
        path: 'overview-warehouse',
        component: OverviewWarehouseComponent,
        canActivate: [PermissionGuard],
        data: { functionName: 'overview-warehouse' }
      },
      { path: 'statistics-by-day', 
        component: StatisticsByDayComponent,
        canActivate: [PermissionGuard],
        data: { functionName: 'statistics-by-day' } 
      },
      { path: 'statistics-ope-by-day', 
        component: StatisticsOpeByDayComponent,
        canActivate: [PermissionGuard],
        data: { functionName: 'statistics-ope-by-day' } 
      },
      { path: 'statistics-returns-by-day', 
        component: StatisticsByDayReturnsComponent,
        canActivate: [PermissionGuard],
        data: { functionName: 'statistics-returns-by-day' } 
      },
      { path: 'statistics-kpi-colli', 
        component: StatisticsKpiColliComponent,
        canActivate: [PermissionGuard],
        data: { functionName: 'statistics-kpi-colli' } 
      },
      { path: 'statistics', 
        component: StatisticsComponent,
        canActivate: [PermissionGuard],
        data: { functionName: 'statistics' } 
      },
      { path: 'statistics-affidati', 
        component: StatisticsAffidatiComponent,
        canActivate: [PermissionGuard],
        data: { functionName: 'statistics-affidati' } 
      },
      { path: 'statistics-consegnati', 
        component: StatisticsConsegnatiComponent,
        canActivate: [PermissionGuard],
        data: { functionName: 'statistics-consegnati' } 
      },
      { path: 'returns', 
        component: ReturnsComponent, 
        canActivate: [PermissionGuard],
        data: { functionName: 'returns' }
      },
      { path: 'returns-history', 
        component: ReturnsHistoryComponent, 
        canActivate: [PermissionGuard],
        data: { functionName: 'returns-history' }
      },
      { path: 'returns-total', 
        component: ReturnsTotalComponent, 
        canActivate: [PermissionGuard],
        data: { functionName: 'returns-total' }
      },      
      { path: 'shipment-request', 
        component: ShipmentRequestComponent, 
        canActivate: [PermissionGuard],
        data: { functionName: 'shipment-request' }
      },
      { path: 'return-request', 
        component: ReturnRequestComponent, 
        canActivate: [PermissionGuard],
        data: { functionName: 'return-request' }
      },
      { path: 'shipment-management', 
        component: ShipmentManagementComponent, 
        canActivate: [PermissionGuard],
        data: { functionName: 'shipment-management' }
      },
      { path: 'loading-list', 
        component: LoadingListComponent, 
        canActivate: [PermissionGuard],
        data: { functionName: 'loading-list' }
      },
      { path: 'loading-list-items/:id', 
        component: LoadingListItemsComponent, 
        canActivate: [PermissionGuard], 
        data: { functionName: 'loading-list-items' } 
      },
      { path: 'change-tour',
            component: ChangeTourComponent,
            canActivate: [PermissionGuard],
            data: { functionName: 'change-tour' }
      },
      {
        path: 'trip-management',
        component: TripManagementComponent,
        canActivate: [PermissionGuard],
        data: { functionName: 'trip-management' }
      },
      {
        path: 'overview-picking',
        component: OverviewPickingComponent,
        canActivate: [PermissionGuard],
        data: { functionName: 'overview-picking' }
      },
      {
        path: 'stock',
        component: StockComponent,
        canActivate: [PermissionGuard],
        data: { functionName: 'stock' }
      },
      { 
        path: 'picking-management',
        loadChildren: () => import('./pages/picking-management/picking-management.module').then(m => m.PickingManagementModule),
        canMatch: [PermissionGuard],
        data: { functionName: 'picking-management' }
      },
      {
        path: 'otm-management',
        loadChildren: () => import('./pages/otm-management/otm-management.module').then(m => m.OtmManagementModule),
        canMatch: [PermissionGuard],
        data: { functionName: 'otm-management' }
      },
      {
        path: 'otm-management-orders',
        loadChildren: () => import('./pages/otm-management-orders/otm-management-orders.module').then(m => m.OtmManagementOrdersModule),
        canMatch: [PermissionGuard],
        data: { functionName: 'otm-management' }
      },
      {
        path: 'otm-management-trips',
        loadChildren: () => import('./pages/otm-management-trips/otm-management-trips.module').then(m => m.OtmManagementTripsModule),
        canMatch: [PermissionGuard],
        data: { functionName: 'otm-management' }
      },
      { 
        path: 'webhook-management',
        loadChildren: () => import('./pages/webhook-management/webhook-management.module').then(m => m.WebhookManagementModule),
        canMatch: [PermissionGuard],
        data: { functionName: 'webhook-management' }
      },
      { 
        path: 'data-exchange-management',
        loadComponent: () => import('./pages/data-exchange-management/data-exchange-management.component').then(m => m.DataExchangeManagementComponent),
        canActivate: [PermissionGuard],
        data: { functionName: 'data-exchange-management' }
      },
      { 
        path: 'eod-report',
        loadComponent: () => import('./pages/eod-report/eod-report.component').then(m => m.EodReportComponent),
        canActivate: [PermissionGuard],
        data: { functionName: 'eod-report' }
      },
      {
        path: 'extra-management',
        loadComponent: () => import('./pages/extra-management/extra-management.component').then(m => m.ExtraManagementComponent),
        canActivate: [PermissionGuard],
        data: { functionName: 'extra-management' }
      },
      {
        path: 'user-management',
        loadChildren: () => import('./pages/user-management/user-management.module').then(m => m.UserManagementModule),
        canMatch: [PermissionGuard],
        data: { functionName: 'user-management' }
      },
      { path: 'reissue', 
        component: ReissueComponent, 
        canActivate: [PermissionGuard],
        data: { functionName: 'reissue' }
      },
      { path: 'about', 
        component: AboutComponent, 
        canActivate: [PermissionGuard],
        data: { functionName: 'about' }
      },
      { 
        path: 'anagraphic',
        loadChildren: () => import('./pages/anagraphic/anagraphic.module').then(m => m.AnagraphicModule),
        canMatch: [PermissionGuard],
        data: { functionName: 'anagraphic' }
      },
      { 
        path: 'picking-scanner',
        loadComponent: () => import('./pages/picking-scanner/picking-scanner.component').then(m => m.PickingScannerComponent),
        canActivate: [PermissionGuard],
        data: { functionName: 'picking-scanner' }
      },
      {
        path: 'barcode-generator',
        loadComponent: () => import('./pages/barcode-generator/barcode-generator.component').then(m => m.BarcodeGeneratorComponent),
        canActivate: [PermissionGuard],
        data: { functionName: 'barcode-generator' }
      },
      {
        path: 'calculator-clock',
        loadComponent: () => import('./pages/calculator-clock/calculator-clock.component').then(m => m.CalculatorClockComponent)
      },
      {
        path: 'logistics-converter',
        loadComponent: () => import('./pages/logistics-converter/logistics-converter.component').then(m => m.LogisticsConverterComponent)
      },
      { path: 'private/tos', // Termini di servizio e Privacy (versione privata, senza PermissionGuard: visibile a tutti gli utenti loggati)
        loadComponent: () => import('./pages/tos/tos.component').then(m => m.TosComponent)
      },
      {
        path: 'pdf-management',
        loadComponent: () => import('./pages/pdf-management/pdf-management.component').then(m => m.PdfManagementComponent),
        canActivate: [PermissionGuard],
        data: { functionName: 'pdf-management' }
      },
      {
        path: 'print-documents',
        loadComponent: () => import('./pages/print-documents/print-documents.component').then(m => m.PrintDocumentsComponent),
        canActivate: [PermissionGuard],
        data: { functionName: 'print-documents' }
      },
      { path: 'dealer-massive-insert', component: DealerMassiveInsertComponent, canActivate: [PermissionGuard], data: { functionName: 'dealer-massive-insert' } },
      {
        path: 'images',
        loadComponent: () => import('./pages/images/images.component').then(m => m.ImagesComponent),
        canActivate: [PermissionGuard],
        data: { functionName: 'images' }
      },
      // TODO: Finance non ancora rilasciato - rotta disabilitata
      // {
      //   path: 'finance',
      //   loadComponent: () => import('./pages/finance/finance.component').then(m => m.FinanceComponent),
      //   canActivate: [PermissionGuard],
      //   data: { functionName: 'finance' }
      // },
      { path: 'system',
        component: SystemComponent,
        canActivate: [PermissionGuard],
        data: { functionName: 'system' }
      },
      { path: 'zone-region',
        loadComponent: () => import('./pages/zone-region/zone-region.component').then(m => m.ZoneRegionComponent),
        canActivate: [PermissionGuard],
        data: { functionName: 'zone-region' }
      },
      { path: 'system-monitoring',
        loadComponent: () => import('./pages/system-monitoring/system-monitoring.component').then(m => m.SystemMonitoringComponent),
        canActivate: [PermissionGuard],
        data: { functionName: 'system-monitoring' }
      },
      // Generazione esempio di bolla (spedizione e reso compilate a mano, solo frontend):
      // card di /system, riservata agli admin e a chi ha la funzione dedicata
      { path: 'waybill-example',
        loadComponent: () => import('./pages/waybill-example/waybill-example.component').then(m => m.WaybillExampleComponent),
        canActivate: [PermissionGuard],
        data: { functionName: 'waybill-example' }
      },
      { path: 'discrepancy-list',
        component: DiscrepancyListComponent,
        canActivate: [PermissionGuard],
        data: { functionName: 'discrepancy-list' }
      },
      { path: 'finance-management',
        loadComponent: () => import('./pages/finance-management/finance-management.component').then(m => m.FinanceManagementComponent),
        canActivate: [PermissionGuard],
        data: { functionName: 'finance-management' }
      },
      { path: 'finance-management/tariffs-management',
        loadComponent: () => import('./pages/finance-management/tariffs-management/tariffs-management.component').then(m => m.TariffsManagementComponent),
        canActivate: [PermissionGuard],
        data: { functionName: 'finance-management' }
      },
      { path: 'finance-management/tariff-scopes-management',
        loadComponent: () => import('./pages/finance-management/tariff-scopes-management/tariff-scopes-management.component').then(m => m.TariffScopesManagementComponent),
        canActivate: [PermissionGuard],
        data: { functionName: 'finance-management' }
      },
      { path: 'finance-management/tariff-brackets-management',
        loadComponent: () => import('./pages/finance-management/tariff-brackets-management/tariff-brackets-management.component').then(m => m.TariffBracketsManagementComponent),
        canActivate: [PermissionGuard],
        data: { functionName: 'finance-management' }
      },
      { path: 'finance-management/tariff-rules-management',
        loadComponent: () => import('./pages/finance-management/tariff-rules-management/tariff-rules-management.component').then(m => m.TariffRulesManagementComponent),
        canActivate: [PermissionGuard],
        data: { functionName: 'finance-management' }
      },
      { path: 'finance-management/tariff-surcharges-management',
        loadComponent: () => import('./pages/finance-management/tariff-surcharges-management/tariff-surcharges-management.component').then(m => m.TariffSurchargesManagementComponent),
        canActivate: [PermissionGuard],
        data: { functionName: 'finance-management' }
      },
      { path: 'finance-management/tariff-queries-management',
        loadComponent: () => import('./pages/finance-management/tariff-queries-management/tariff-queries-management.component').then(m => m.TariffQueriesManagementComponent),
        canActivate: [PermissionGuard],
        data: { functionName: 'finance-management' }
      },
    ],
  },
  { path: '**', redirectTo: '', pathMatch: 'full' }, // Fallback per rotte non trovate
];

export const routes: Routes = environment.maintenanceMode ? maintenanceRoutes : applicationRoutes;